import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Packages from "@/components/Packages";
import Process from "@/components/Process";
import CaseStudy from "@/components/CaseStudy";
import Approach from "@/components/Approach";
import Reels from "@/components/Reels";
import Booking from "@/components/Booking";
import Founder from "@/components/Founder";
import Team from "@/components/Team";
import HappyClients from "@/components/HappyClients";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import ContactForm from "@/components/ContactForm";

function Marquee() {
    const items = ["Brand Identity", "Personal Branding", "Content", "Lead Generation", "Positioning", "Dubai Real Estate"];
    return (
        <div className="relative border-y border-white/10 bg-[#0d0d0f] py-6 overflow-hidden">
            <div className="flex whitespace-nowrap animate-marquee">
                {[0, 1].map((r) => (
                    <div key={r} className="flex items-center gap-14 pr-14">
                        {items.map((t) => (
                            <span key={t + r} className="inline-flex items-center gap-8 font-display font-semibold text-3xl sm:text-5xl tracking-[-0.04em] text-white/70">
                                {t} <span className="text-brand text-4xl">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

function SectionReveal({ children, delay = 0 }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
}

export default function Home() {
    return (
        <div className="relative">
            <Navbar />
            <main className="relative z-10">
                <Hero />
                <Marquee />
                {/* 1. Offering — clarify what they get */}
                <SectionReveal><Services /></SectionReveal>
                {/* 2. Proof — real numbers, real deals */}
                <SectionReveal><CaseStudy /></SectionReveal>
                {/* 3. Show the work — visual proof */}
                <SectionReveal><Reels /></SectionReveal>
                {/* 4. Social proof — logos of happy clients */}
                <SectionReveal><HappyClients /></SectionReveal>
                {/* 5. Voices — what clients say */}
                <SectionReveal><Testimonials /></SectionReveal>
                {/* 6. Method — how we deliver */}
                <SectionReveal><Approach /></SectionReveal>
                {/* 7. Founder — the human behind the brand */}
                <SectionReveal><Founder /></SectionReveal>
                {/* 8. Team — who actually does the work */}
                <SectionReveal><Team /></SectionReveal>
                {/* 9. Investment — packages */}
                <SectionReveal><Packages /></SectionReveal>
                {/* 10. Onboarding — how easy it is to start */}
                <SectionReveal><Process /></SectionReveal>
                {/* 11. Booking CTA — grab the call */}
                <SectionReveal><Booking /></SectionReveal>
                {/* 12. Objections — FAQ */}
                <SectionReveal><FAQ /></SectionReveal>
                {/* 13. Final catch-all — contact form */}
                <SectionReveal><ContactForm /></SectionReveal>
            </main>
            <Footer />
        </div>
    );
}
